import React, { useCallback } from 'react';
import { Select } from 'antd';
import { debounce } from 'lodash';
import SpinLoading from '../spin-loading';

const FilterSearch = props => {
  const {
    className,
    value = [],
    options = [],
    mode = 'multiple',
    showSearch,
    showArrow,
    allowClear,
    maxTagCount = 1,
    placeholder,
    isLoading = false,
    onChange,
    onSearch,
    onScrollEnd,
  } = props;

  const handleScroll = useCallback(
    debounce(e => {
      const { target } = e;
      if (target.scrollHeight - target.scrollTop <= target.clientHeight) {
        onScrollEnd?.();
      }
    }, 500),
    [onScrollEnd],
  );

  const handleSearch = useCallback(
    debounce(value => {
      onSearch?.(value);
    }, 500),
    [onSearch],
  );

  const handleBlur = () => {
    onSearch?.('');
  };

  return (
    <Select
      className={`filter-search ${className}`}
      value={value}
      loading={isLoading}
      showSearch={showSearch}
      showArrow={showArrow}
      filterOption={false}
      mode={mode}
      maxTagCount={maxTagCount}
      allowClear={allowClear}
      placeholder={placeholder}
      getPopupContainer={triggerNode => triggerNode.parentNode}
      onChange={onChange}
      onSearch={handleSearch}
      onPopupScroll={handleScroll}
      onBlur={handleBlur}
      dropdownRender={menu => {
        if (isLoading && !options?.length) {
          return <SpinLoading className="filter-search__search-loading" />;
        } else {
          return menu;
        }
      }}
    >
      {options.map(item => (
        <Select.Option value={item.value} key={item.value}>
          {item.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default FilterSearch;
